import resourceReducerFactory, { resourceState } from 'reducers/resource';
import { types } from 'actions/profiles';

export const initialState = {
  ...resourceState,
};

export default resourceReducerFactory(initialState, types);
